import { StyleSheet, Text, View, ScrollView } from "react-native";
import React, { useEffect, useState } from "react";
import InputText from "../../../../components/InputText";
import { Button, useTheme } from "react-native-paper";
import useApi from "../../../../hooks/useAPI";
import { SafeAreaView } from "react-native-safe-area-context";
import { showMessage } from "react-native-flash-message";
import { Dropdown } from "react-native-material-dropdown";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import createCardFirstStepSchema from "../../../../schemas/createCardFirstStepSchema";
import { mask } from "react-native-mask-text";
import LinearLoading from "../../../../components/LinearLoading";
type inputsData = {
  dob: string;
  studentId: string;
  institution: string;
};

type Props = {
  setIsFirstStepDone: (action: boolean) => void;
  setStudentId: (action: string) => void;
  setInstitution: (action: string) => void;
  setDob: (action: string) => void;
};

const CreateCardFirstStepScreen = ({
  setIsFirstStepDone,
  setStudentId,
  setInstitution,
  setDob,
}: Props) => {
  const { colors } = useTheme();
  const api = useApi();
  const [institutionsArray, setInstitutionsArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<inputsData>({
    resolver: joiResolver(createCardFirstStepSchema),
  });

  useEffect(() => {
    const request = api.createCard.getInstitutions();
    request.then((response) => {
      setInstitutionsArray(response.data);
    });
    request.catch((error) => {
      console.log(error.response.data);
    });
  }, []);

  const onSubmit = async (data: inputsData) => {
    setLoading(true);

    const dateParts = data.dob?.split("/");
    const correctedDate = new Date(
      +dateParts[2],
      Number(dateParts[1]) - 1,
      +dateParts[0]
    )
      .toISOString()
      ?.split("T")[0];

    const request = api.createCard.checkCredentials({
      student_id: data.studentId,
      institution: data.institution,
      dob: correctedDate,
    });

    request.then(() => {
      showMessage({ type: "success", message: "Credenciais válidas." });
      setStudentId(data.studentId);
      setInstitution(data.institution);
      setDob(correctedDate);
      setIsFirstStepDone(true);
      setLoading(false);
    });
    request.catch((error) => {
      showMessage({ type: "danger", message: "Credenciais não encontradas, confira as informações inseridas." });
      setLoading(false);
    });
  };

  return (
    <SafeAreaView style={styles.root}>
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>Criar carteira</Text>
          <Text style={styles.subtitle}>
            Primeiro, insira as informações referentes à instituição e data de
            nascimento do aluno.
          </Text>
        </View>

        <View style={{ width: "100%", paddingHorizontal: 24 }}>
          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Dropdown
                  label="Escolha sua instituição:"
                  data={institutionsArray?.map((institution: any) => {
                    return { value: institution._name };
                  })}
                  onChangeText={onChange}
                  value={value}
                  baseColor={
                    errors?.institution ? colors.error : colors.primary
                  }
                  labelFontSize={16}
                  onBlur={onBlur}
                  disabled={loading}
                />
              )}
              name="institution"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="Número de matrícula"
                  value={value}
                  onChange={onChange}
                  style={[
                    styles.inputs,
                    {
                      borderColor: errors.studentId
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={errors.studentId ? colors.error : colors.text}
                  placeholderTextColor={
                    errors.studentId ? colors.error : colors.text
                  }
                  onBlur={onBlur}
                  disabled={loading}
                />
              )}
              name="studentId"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="Data de nascimento"
                  value={value}
                  onChange={(value) => {
                    const maskedValue = mask(value, "99/99/9999");
                    onChange(maskedValue);
                  }}
                  style={[
                    styles.inputs,
                    {
                      borderColor: errors.dob
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={errors.dob ? colors.error : colors.text}
                  placeholderTextColor={errors.dob ? colors.error : colors.text}
                  onBlur={onBlur}
                  disabled={loading}
                />
              )}
              name="dob"
            />
          </View>
          <View style={{alignItems: "center",marginBottom:100}}>
            <Button
              style={styles.btn}
              labelStyle={styles.btnText}
              mode="contained"
              onPress={handleSubmit(onSubmit)}
              disabled={loading}
            >
              Continuar
            </Button>
            {loading ? <LinearLoading /> : <View style={styles.emptyLoader} />}
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};
export default CreateCardFirstStepScreen;

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#fff",
    padding: -25,
  },
  container: {
    alignItems: "center",
  },
  inputs: {
    marginTop: 10,
    width: "100%",
    zIndex: 0,
    borderWidth: 1,
    color: "#999999",
  },
  header: {
    width: "100%",
    paddingHorizontal: 24,
  },
  title: {
    fontWeight: "600",
    fontSize: 32,
    marginBottom: 12,
  },
  subtitle: {
    fontWeight: "200",
    fontSize: 15,
    marginBottom: 16,
  },
  btn: {
    marginTop: 20,
    marginBottom: 10,
    borderRadius: 25,
    height: 50,
    width:"100%" 
  },
  btnText: {
    color: "#fff",
    fontSize: 15,
    lineHeight: 30,
  },
  card: {
    marginTop: 10,
    marginBottom: 10,
    width: "90%",
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
  },
  placeHolder: {
    fontSize: 15,
    fontWeight: "300",
  },
  cardContent: {
    position: "absolute",
    left: 25,
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },
  inputsMargin: {
    marginBottom: 16,
  },
  addPicture: {
    marginTop: 10,
    marginBottom: 10,
    width: "90%",
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
  },
  addPictureText: {
    color: "#999999",
  },
  maskedInput: {
    borderWidth: 2,
    borderRadius: 6,
    width: "80%",
    padding: 12,
    color: "black",
    fontSize: 20,
  },
  dobInput: {
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
    borderWidth: 1,
  },
});
